export const setView = (state, {view, index, meta, parentKey, parentID}) => {
  state.views[view].index = {}

  index.forEach((entity) => {
    state.views[view].index = {
      ...state.views[view].index,
      [entity.id]: entity
    }
  })

  state.views[view].ids = Object.keys(state.views[view].index)

  if (meta) {
    state.views[view].meta = {
      ...state.views[view].meta,
      ...meta
    }
  }
}

export const setComplete = (state, {index}) => {
  state.complete.index = {}

  index.forEach((entity) => {
    state.complete.index = {
      ...state.complete.index,
      [entity.id]: entity
    }
  })

  state.complete.ids = Object.keys(state.complete.index)
}

export const setCurrent = (state, current) => {
  state.current = current
}

export const setFetching = (state, value) => {
  state.fetching = value
}

export const setFetchingForView = (state, {view, value})  => {
  state.views[view].fetching = value
}

export const upsert = (state, {view, entity}) => {
  state.views[view].index = {
    ...state.views[view].index,
    [entity.id]: entity
  }

  state.views[view].ids = Object.keys(state.views[view].index)
}

export const patch = (state, {view, id, update}) => {
  state.views[view].index[id] = {
    ...state.views[view].index[id],
    ...update
  }
}

export const remove = (state, {view, id}) => {
  delete state.views[view].index[id]
  state.views[view].ids = Object.keys(state.views[view].index)
}

export const bulkUpdate = (state, entities) => {
  entities.forEach((entity) => {
    state.index[entity.id] = {
      ...state.index[entity.id],
      ...entity
    }
  })
}
export const setMetaProp = (state, {view, prop, value}) => {
  state.views[view].meta[prop] = value
}



// WEBPACK FOOTER //
// ./src/helpers/store-helpers.js